/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Lifetime_VolumeInputs */

const en_us2_progress_extra_lifetime_volume = /** @type {(inputs: Progress_Extra_Lifetime_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lifted`)
};

const pt_br2_progress_extra_lifetime_volume = /** @type {(inputs: Progress_Extra_Lifetime_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`levantados`)
};

const es_419_progress_extra_lifetime_volume = /** @type {(inputs: Progress_Extra_Lifetime_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`levantados`)
};

const pt_pt2_progress_extra_lifetime_volume = /** @type {(inputs: Progress_Extra_Lifetime_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`levantados`)
};

const fr_fr2_progress_extra_lifetime_volume = /** @type {(inputs: Progress_Extra_Lifetime_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`soulevés`)
};

const de_de2_progress_extra_lifetime_volume = /** @type {(inputs: Progress_Extra_Lifetime_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bewegt`)
};

const it_it2_progress_extra_lifetime_volume = /** @type {(inputs: Progress_Extra_Lifetime_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sollevati`)
};

/**
* | output |
* | --- |
* | "lifted" |
*
* @param {Progress_Extra_Lifetime_VolumeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_lifetime_volume = /** @type {((inputs?: Progress_Extra_Lifetime_VolumeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Lifetime_VolumeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_lifetime_volume(inputs)
	if (locale === "es-419") return es_419_progress_extra_lifetime_volume(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_lifetime_volume(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_lifetime_volume(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_lifetime_volume(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_lifetime_volume(inputs)
	return en_us2_progress_extra_lifetime_volume(inputs)
});
export { progress_extra_lifetime_volume as "progress-extra.lifetime_volume" }